import { Column, Row } from "components/styles";
import { Fields } from "./styles";
import { Description } from "components/CustomCheckbox/styles";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import { RESOURCES_CONSTANTS, RESOURCE_MODULE_IDS } from "config/constants";
import { handlerKeyPressOnlyNumbers } from "utils/validations";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import useChangeBlockListByPenalize from "views/Recursos/ResourcesLibrary/SchedulesWrapper/ReservationData/utils/hooks/useChangeBlockListByPenalize";
import useChangePenaltiesByReasonForPenalize from "views/Recursos/ResourcesLibrary/SchedulesWrapper/ReservationData/utils/hooks/useChangePenaltiesByReasonForPenalize";

const { REASON_FOR_PENALIZE_IDS } = RESOURCES_CONSTANTS;

const UpdatePenaltyForm = ({
    form,
    subtitle,
    data: {
        campusSpaceList,
        resourceTypes,
        reasonsForPenalizeByResourceOrSpace,
        blockList, penaltyTypeList
    },
    historyComponent
}) => {
    //#region Functions
    const changePenalizeDays = value => {
        form.change("penalizeDays", value);
    }
    const changePenaltyTypeId = value => {
        form.change("penaltyTypeId", value);
    }
    const changeBlockId = value => {
        form.change("blockId", value);
    }
    //#endregion
    const {
        resourceModuleId,
        resourceTypeId,
        reasonForPenalizeId,
        penaltyTypeId, blockId, 
        penalizeDays, 
        details
    } = form.value;
    const { penaltyTypeListFiltered } = useChangePenaltiesByReasonForPenalize({
        penaltyTypeList,
        reasonForPenalizeId,
        changePenalizeId: changePenaltyTypeId
    });
    const { blockListFiltered } = useChangeBlockListByPenalize({
        blockList, penaltyTypeId,
        changeBlockId, isUpdate: true
    });
    function renderReasonForPenalize() {
        return (
            <CustomSelect
                label="Motivo"
                value={reasonForPenalizeId}
                onChange={() => {}}
                defaultOptionText="Elige un Motivo"
                optionsProps={getOptionsToCustomSelect(
                    reasonsForPenalizeByResourceOrSpace, 
                    { id: "id", text: "name" }
                )}
                disabled/>
        );
    }
    function renderPenalizeDaysControl() {
        return (
            <CustomTextInput
                label="Días de sanción"
                placeholder="Días"
                value={penalizeDays}
                minWidth="170px"
                width="170px"
                maxLength={3}
                onKeyPress={handlerKeyPressOnlyNumbers}
                onChange={changePenalizeDays}/>
        );
    }
    return (
        <Column className="custom-scrollbar primary" 
            height="40vh"
            maxHeight="500px">
            <p className="paragraph center">{subtitle}</p>
            <Fields className="custom-scrollbar primary">
                <Row justifyContent="flex-start" align="flex-start">
                    <CustomSelect
                        label="Tipo de espacio"
                        value={resourceModuleId}
                        onChange={() => {}}
                        defaultOptionText="Elige un tipo de espacio"
                        optionsProps={getOptionsToCustomSelect(campusSpaceList, { id: "id", text: "name" })}
                        disabled/>
                    {resourceModuleId === RESOURCE_MODULE_IDS.UNIVERSITY_SPACES && 
                    <>
                        {renderReasonForPenalize()}
                        {renderPenalizeDaysControl()}
                    </>}
                    {resourceModuleId === RESOURCE_MODULE_IDS.LIBRARY && 
                    <Column width="max-content">
                        <Description className="disabled">Recursos</Description>
                        <Row maxWidth="max-content" minWidth="max-content">
                            {resourceTypes.map(({
                                id, name
                            }) => (
                                <CustomCheckbox
                                    key={id}
                                    label={name}
                                    checked={resourceTypeId === id}
                                    onChange={() => {}}
                                    padding="5px 0"
                                    disabled/>
                            ))}
                        </Row>
                    </Column>}
                </Row>
                {resourceModuleId === RESOURCE_MODULE_IDS.LIBRARY && 
                <Row justifyContent="flex-start">
                    {renderReasonForPenalize()}
                    {reasonForPenalizeId !== REASON_FOR_PENALIZE_IDS.NO_REFUND && renderPenalizeDaysControl()}
                    {reasonForPenalizeId === REASON_FOR_PENALIZE_IDS.NO_REFUND &&
                    <>
                    <CustomSelect
                        label="Sanción"
                        value={penaltyTypeId}
                        onChange={changePenaltyTypeId}
                        defaultOptionText="Elige un Sanción"
                        optionsProps={getOptionsToCustomSelect(penaltyTypeListFiltered, { id: "id", text: "name" })}
                        disabled={penaltyTypeListFiltered.length === 1}/>
                    <CustomSelect
                        label="Bloqueo"
                        value={blockId}
                        onChange={changeBlockId}
                        defaultOptionText="Elige un Bloqueo"
                        optionsProps={getOptionsToCustomSelect(blockListFiltered, { id: "id", text: "name" })}/>
                    </>}
                </Row>}
                <CustomTextArea
                    label="Detalles" 
                    placeholder="Describe el motivo de la sanción"
                    value={details}
                    onChange={() => {}}
                    showCharCounter={false}
                    maxLength={400}
                    height="50px"
                    disabled/>
                {historyComponent}
            </Fields>
        </Column>
    );
}

export default UpdatePenaltyForm;